import { BasicObjectViewModel } from '@/engine/app/models/BasicObjectViewModel';
import { SceneItemKind, Transparency } from '@/engine/app/interfaces';
import { v4 as uuid } from 'uuid';

export class AnnotationViewModel extends BasicObjectViewModel {
  private _originViewPortDescriptor?: string;

  private _isNewInstance = true;

  public constructor({
    descriptor,
    isVisible,
    phaseId,
    color,
    highlightColor,
    selectionColor,
    label,
    isPickable,
    isTunable,
    isBeingEdited
  }: {
    phaseId?: string;
    label: string;
    descriptor?: string;
    isVisible?: boolean;
    color: string;
    highlightColor: string;
    selectionColor: string;
    isPickable: boolean;
    isTunable: boolean;
    isBeingEdited: boolean;
  }) {
    super({
      kind: SceneItemKind.IndicatedAnnotation,
      descriptor: descriptor ?? uuid(),
      isVisible: isVisible ?? true,
      label,
      phaseId: phaseId ?? '',
      attachments: [],
      details: undefined,
      color,
      highlightColor,
      selectionColor,
      isVertexColoring: false,
      isContourVisible: false,
      isHighlighted: false,
      isSelected: false,
      isPickable: isPickable,
      isTunable: isTunable,
      isBeingEdited: isBeingEdited,
      isClippable: false,
      imported: false,
      isAvailable: true,
      transparency: Transparency.Opaque
    });
  }

  public setOriginViewPortDescriptor(originViewPortDescriptor: string): void {
    this._originViewPortDescriptor = originViewPortDescriptor;
  }

  public get originViewPortDescriptor(): string | undefined {
    return this._originViewPortDescriptor;
  }

  public setNewInstanceToFalse(): void {
    this._isNewInstance = false;
  }

  public get isNewInstance(): boolean {
    return this._isNewInstance;
  }
}
